import React, { useState, useEffect } from "react";
import { Button } from "components/haven-design/buttons";
import styles from "./Login.module.css";

const RESEND_TIME_SECONDS = 10;

const TimerButton: React.FC<{sendCode: () => void;}> = ({ sendCode }) => {
  const [timeLeft, setTimeLeft] = useState<number>(RESEND_TIME_SECONDS);

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);

      return () => {
        clearTimeout(timer);
      };
    }
    return () => null;
  }, [timeLeft]);

  const handleClick = () => {
    setTimeLeft(RESEND_TIME_SECONDS);
    sendCode();
  };

  const isDisabled = timeLeft > 0;

  return (
    <Button
      color="secondary"
      fullWidth
      className={styles.loginButton}
      disabled={isDisabled}
      onClick={handleClick}
    >
      {isDisabled ? `Resend code in ${timeLeft} seconds` : "Resend Code"}
    </Button>
  );
};

export default TimerButton;
